module.exports = __webpack_public_path__ + "static/img/图层3.0826782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层3.png
// module id = v2S2
// module chunks = 0